/**
 * Fine-grained permissions, layered on top of `UserRole`.
 *
 * Roles remain the primary authorization mechanism everywhere else in the app;
 * this exists because the support inbox has to be grantable to individual
 * `support` and `marketing` users without giving them a whole new role.
 * `UserRole.admin` holds every permission implicitly - see `allPermissions`.
 *
 * Scope note: these gate SUPPORT conversations only. Direct messages and
 * groups are gated by membership, and creating or managing a group is gated by
 * `UserRole.admin` rather than by a permission.
 */
export enum UserPermission {
  conversationRead = 'conversationRead',
  conversationWrite = 'conversationWrite',
}

export type UserPermissionsResponse = {
  permissions: UserPermission[];
  /**
   * True when the role itself grants everything (admin), regardless of what
   * `permissions` contains. Always check this first.
   */
  allPermissions: boolean;
};

export type SetUserPermissionsDto = {
  /** Full replacement - anything omitted is revoked. */
  permissions: UserPermission[];
};
